(() => {
  class AccrodionWrapper extends HTMLElement {
    constructor() {
      super();
      this.activeAccordion = null;
      this.activeAccordionPrevTop = null;

      this.resizeObserver = new ResizeObserver(this.onResize.bind(this));
      this.resizeObserver.observe(this);
      this.onClick = this.saveValues.bind(this);
      this.addEventListener("click", this.onClick);
    }

    disconnectedCallback() {
      this.resizeObserver.unobserve(this);
      this.resizeObserver.disconnect();
      this.removeEventListener("click", this.onClick);
    }

    onResize() {
      if (!this.activeAccordion) return;

      const top = this.activeAccordion.getBoundingClientRect().top;
      const distance = top - this.activeAccordionPrevTop;
      if (!distance) return;

      window.scrollTo({
        top: window.scrollY + distance,
        behavior: "instant",
      });
    }

    saveValues() {
      this.activeAccordion = this.querySelector(".open");
      this.activeAccordionPrevTop = this.activeAccordion?.getBoundingClientRect().top;
    }
  }
  customElements.define("accordion-wrapper", AccrodionWrapper);
})();
